export const initialState = {
  loadingStatus: {
    projectIdentificationListLoading: false,
    projectIdentificationDetailLoading: false,
    createProjectIdentificationLoading: false,
    updateProjectIdentificationLoading: false,
  },
  error: '',
  projectIdentificationList: {
    data: [],
    offset: 0,
    limit: 0,
    total: 0,
  },
  projectIdentificationDetail: {},
};
